import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: ({ depth }) => `calc(13rem - ${depth * 13}px)`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    [theme.breakpoints.down(960)]: {
      maxWidth: ({ depth }) => `calc(58vw - ${depth * 13}px)`
    }
  }
}))

export default useStyles
